if (!customElements.get('wls-product-upsell')) {
    class WLSUpsell extends HTMLElement {
        constructor() {
            super();
            this.cart = document.querySelector('wls-cart');
        }

        connectedCallback() {
            this.initializeElements();
            this.bindEvents();
        }

        initializeElements() {
            this.subscriptionRadio = this.querySelectorAll('input[id="upsell-subscription"]');
            this.priceElement = this.querySelector('.js-upsell-product-price');
            this.addToCartButtons = this.querySelectorAll('.js-upsell-add-to-cart'); // updated to all buttons
        }

        bindEvents() {
            this.subscriptionRadio.forEach((radio) => {
                radio.addEventListener('click', () => this.handleSubscriptionChange(radio));
            });

            this.addToCartButtons.forEach((button) => {
                button.addEventListener('click', () => this.handleAddToCartClick(button));
            });
        }

        handleSubscriptionChange(radio) {
            const subscriptionWrapper = radio.closest('[wls-subscription]');
            const price = subscriptionWrapper.dataset.price;
            const sellingPlanId = subscriptionWrapper.dataset.sellingPlanId;

            this.updatePrice(price);
            this.updateSellingPlan(sellingPlanId);
        }

        updatePrice(price) {
            this.priceElement.innerHTML = price;
        }

        updateSellingPlan(sellingPlanId) {
            this.addToCartButtons.forEach((button) => {
                button.dataset.sellingPlanId = sellingPlanId;
            });
        }

        handleAddToCartClick(button) {
            const id = button.dataset.productId;
            const quantity = 1;
            const sellingPlanId = button.dataset.sellingPlanId;

            fetch(window.location.origin + '/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    items: [{
                        id: id,
                        quantity: quantity,
                        selling_plan: sellingPlanId
                    }]
                })
            }).then(response => {
                if (response.ok) {
                    this.refreshCart();
                }
            });
        }

        refreshCart() {
            fetch('/cart')
                .then(res => res.text())
                .then(html => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');
                    const newCart = doc.querySelector('cart-drawer');
                    const newCartPage = doc.querySelector('wls-cart');
                    const currentCart = document.querySelector('cart-drawer');
                    const currentCartPage = document.querySelector('wls-cart');

                    if (newCart) {
                        currentCart.replaceWith(newCart);
                        if (!window.location.pathname.includes('/cart')) {
                            window.Wollson.showCart();
                        }
                    } else {
                        console.error('No <wls-cart> found in response HTML');
                    }

                    if (newCartPage) {
                        currentCartPage.replaceWith(newCartPage);
                    }
                })
                .catch(err => console.error('Error refreshing cart:', err));
        }
    }

    window.customElements.define('wls-product-upsell', WLSUpsell);
}
